export default __webpack_public_path__ + "static/media/frame2.d83eb8f3.svg";